import { Link, useNavigate, useParams } from "react-router-dom";
import { handleBackToSiteMaterial } from "./adminHelper";
import AdminNavBar from "./components/AdminNavBar";
import { ChangeEvent, useState } from "react";
import { AxiosResponse } from "axios";
import Loading from "../components/LoadingComponent";
import ErrorComponent from "../components/ErrorComponent";
import apiService from "../services/api.service";
import adminUseFetchBookChapters from "../custom_hook/adminUseFetchBookChapters";

const ChapterForm = () => {
  const { bookId } = useParams();
  const navigate = useNavigate();
  const { chapters, book, loading, error } = adminUseFetchBookChapters(
    bookId || ""
  );

  const [chapter, setChapter] = useState({
    title: "",
    number: "",
    completion_status: "Pending",
    book: book?.id,
  });

  const handleInputChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>
  ) => {
    setChapter({
      ...chapter,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmitChapter = async (e: React.FormEvent) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("title", chapter.title);
    formData.append("number", chapter.number);
    formData.append("completion_status", chapter.completion_status);
    formData.append("book", book?.id.toString() || "");

    let chapterExists = false;
    chapters.forEach((chapt) => {
      if (
        chapt.title === chapter.title ||
        chapt.number.toString() === chapter.number
      ) {
        chapterExists = true;
      }
    });
    const makePostRequest = async () => {
      if (chapterExists) {
        alert("Chapter already exist");
      } else {
        try {
          await apiService.post<AxiosResponse>("/chapters/", formData);
          alert("Chapter created successfully");
        } catch (error: any) {
          console.error("Error occured while creating chapter", error);
          if (error.response && error.response.status === 401) {
            throw new Error("Token expired");
          }
          throw error;
        }
      }
    };

    try {
      await makePostRequest();
    } catch (error: any) {
      console.error("Error occurred while creating chapter", error);
      alert("Failed to creating chapter. Please try again.");
    }
  };

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <ErrorComponent message={error.message} />;
  }

  return (
    <>
      <nav className="navbar navbar-dark bg-dark">
        <AdminNavBar />
      </nav>
      <nav id="bc-nav" aria-label="breadcrumb">
        <ol id="bc-ol" className="breadcrumb">
          <li id="bc-books" className="breadcrumb-item">
            <button
              className="inactive-anchor-link"
              onClick={() => {
                handleBackToSiteMaterial(navigate);
              }}
            >
              Site Materials
            </button>{" "}
            <span className="greater-than">&#x02AA2;</span>
          </li>
          <Link
            to={`/admin/site-materials/books`}
            className="breadcrumb-item inactive-anchor-link"
          >
            Books <span className="greater-than">&#x02AA2;</span>
          </Link>
          <Link
            to={`/admin/site-materials/books/${bookId}/chapters`}
            className="breadcrumb-item inactive-anchor-link"
          >
            {book?.title} <span className="greater-than">&#x02AA2;</span>
          </Link>
          <li id="bc-active" className="breadcrumb-item active">
            Create
          </li>
        </ol>
      </nav>

      <form id="chapter-form" className="mb-3" onSubmit={handleSubmitChapter}>
        <div className="mb-3">
          <label htmlFor="chapter-title" className="form-label">
            Title
          </label>
          <input
            className={"form-control"}
            id="chapter-title"
            type="text"
            name="title"
            value={chapter.title}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label"> Chapter Number</label>
          <input
            className={"form-control"}
            type="text"
            name="number"
            value={chapter.number}
            onChange={handleInputChange}
            required
          />
        </div>
        <div className="mb-3">
          <label className="form-label"> Completion Status </label>
          <select
            className="form-select"
            name="completion_status"
            value={chapter.completion_status}
            onChange={handleInputChange}
            required
          >
            <option value="Pending">Pending</option>
            <option value="Under Review">Under Review</option>
            <option value="Completed">Completed</option>
          </select>
        </div>
        <button
          id="create-post-btn"
          className="btn error-page-btn"
          type="submit"
        >
          Add Chapter
        </button>
      </form>
    </>
  );
};

export default ChapterForm;
